/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProfileSuggestionType = {
    MaltProject: 'MALT_PROJECT',
    RecentExperience: 'RECENT_EXPERIENCE',
    OngoingExperience: 'ONGOING_EXPERIENCE',
    Portfolio: 'PORTFOLIO',
    Recommendation: 'RECOMMENDATION'
} as const;
export type ProfileSuggestionType = typeof ProfileSuggestionType[keyof typeof ProfileSuggestionType];


export function instanceOfProfileSuggestionType(value: any): boolean {
    for (const key in ProfileSuggestionType) {
        if (Object.prototype.hasOwnProperty.call(ProfileSuggestionType, key)) {
            // @ts-ignore
            if (ProfileSuggestionType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProfileSuggestionTypeFromJSON(json: any): ProfileSuggestionType {
    return ProfileSuggestionTypeFromJSONTyped(json, false);
}

export function ProfileSuggestionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileSuggestionType {
    return json as ProfileSuggestionType;
}

export function ProfileSuggestionTypeToJSON(value?: ProfileSuggestionType | null): any {
    return value as any;
}

